module.exports = __webpack_public_path__ + "static/media/proximanova-bold-webfont.28f22331.woff2";